import React from 'react'
import { Link } from 'react-router-dom'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faHome, faSearch, faBook} from '@fortawesome/free-solid-svg-icons';

function Sidebar() {
  return (
    <>
        <nav className="navbar sidebar">
            <Link to="/" className='d-flex flex-row pt-2 pb-3 justify-content-center text-center'>       
                <img className='mx-1' src="/favicon.ico" width="45px" alt="logo" />
                <h4 className='mt-2'>Spotify</h4>
            </Link>
            <ul className='nav'>
                <li className='nav-item'>
                    <Link className="nav-link" to="/"><FontAwesomeIcon icon={faHome}/> Home</Link>
                </li>
                <li className='nav-item'>
                    <Link className="nav-link" to="/search"><FontAwesomeIcon icon={faSearch}/> Search</Link>
                </li>
                <li className='nav-item'>
                    <Link className="nav-link" to="/library"><FontAwesomeIcon icon={faBook}/> Your Library</Link>
                </li>
            </ul>
            {/* <p className='mt-auto'>
                &copy; Englishcha
            </p> */}
        </nav>
    </>
  )
}

export default Sidebar